import { render } from "./ConfigurationStatsView.vue?vue&type=template&id=2098e510&scoped=true"
import script from "./ConfigurationStatsView.vue?vue&type=script&lang=js"
export * from "./ConfigurationStatsView.vue?vue&type=script&lang=js"

import "./ConfigurationStatsView.vue?vue&type=style&index=0&id=2098e510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2098e510"]])

export default __exports__